import React from 'react';
import styled from 'styled-components';

import { FireInfoIcon } from './fireInfoIcon';
import { DistanceIcon } from '../icons/distanceIcon';
import { SizeIcon } from '../icons/sizeIcon';
import { WindIcon } from '../icons/windIcon';

interface FireInfoType {
    name?: string;
    distance: number;
    windSpeed: number;
    windDirection: string;
    windSpeedUnit: string;
    distanceUnit: string;
    burningAcres?: string;
}

export const FireInfo = ({ 
    name,
    distance,
    windSpeed,
    windDirection,
    windSpeedUnit,
    distanceUnit,
    burningAcres
}:FireInfoType) => {
    const fireName = name || 'Unnamed fire';
    return (
        <Container>
            <Header>
                <FireInfoIconContainer>
                    <FireInfoIcon />
                </FireInfoIconContainer>
                <span>
                    {fireName}
                </span>
            </Header>
            <InfoContainer>
                <InfoSection>
                    <DistanceIcon />
                    <InfoTextContainer>
                        <ContentText>
                            {distance}&nbsp;{distanceUnit}
                        </ContentText>
                        <InfoText>
                            From your Location
                        </InfoText>
                    </InfoTextContainer>
                </InfoSection>
                <InfoSection>
                    <WindIcon />
                    <InfoTextContainer>
                        <ContentText>
                            {windDirection}&nbsp;&#8226;&nbsp;{windSpeed}&nbsp;{windSpeedUnit}
                        </ContentText>
                        <InfoText>
                            Forward Wind
                        </InfoText>
                    </InfoTextContainer>
                </InfoSection>
                {burningAcres && <InfoSection>
                    <SizeIcon />
                    <InfoTextContainer>
                        <ContentText>
                            {burningAcres}&nbsp;Acres
                        </ContentText>
                        <InfoText>
                            Size
                        </InfoText>
                    </InfoTextContainer>
                </InfoSection>}
            </InfoContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #FFFFFF;
    color: #666666;
    font-size: 16px;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 300;
`;

const Header = styled.div`
    border-bottom-width: 1px;
    border-bottom-color: #BCBBC1;
    border-bottom-style: solid;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 300;
`;

const FireInfoIconContainer = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    flex-direction: row;
`;

const InfoContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top: 8px;
`;

const InfoSection = styled.div`
    display: flex;
    padding-left: 8px;
    padding-bottom: 8px;
    width: 47%;
`;

const InfoTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 8px;
`;

const ContentText = styled.span`
    padding-bottom: 4px;
`;

const InfoText = styled.span`
    font-size: 14px;
    font-weight: 200;
`;
